import { BreadcrumbItem } from '@mi-front/ui';
import { MessageDescriptor } from 'react-intl';

export interface BreadcrumbItemConfig {
  href?: string;
  message: MessageDescriptor;
  active?: boolean;
}

export const auditConfigBreadcrumbItem = (
  formatMessage: (descriptor: MessageDescriptor) => string,
): BreadcrumbItem => ({
  href: '/audit/config',
  content: formatMessage({
    id: 'audit.configScreen.title',
    defaultMessage: 'Audit config',
  }),
});

export const reportDefinitionsBreadcrumbItem = (
  formatMessage: (descriptor: MessageDescriptor) => string,
  reportType: string,
): BreadcrumbItem => ({
  href: `/audit/config/report-definitions/${reportType}`,
  content: formatMessage({
    id: 'audit.reportDefinitionList.title',
    defaultMessage: 'Plantillas de reporte',
  }),
});

export const globalReportsBreadcrumbItem = (
  formatMessage: (descriptor: MessageDescriptor) => string,
): BreadcrumbItem => ({
  href: '/audit/global-reports',
  content: formatMessage({
    id: 'audit.globalReports.title',
    defaultMessage: 'Audit global',
  }),
});

export const createdReportsBreadcrumbItem = (
  formatMessage: (descriptor: MessageDescriptor) => string,
): BreadcrumbItem => ({
  href: '/audit/saved-reports',
  content: formatMessage({
    id: 'audit.reportsList.title',
    defaultMessage: 'Reportes guardados',
  }),
});
